<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-cogs page-operative-data-analysis-cogs-edit">
    <div class="container">
      <PageTitle>Modifica costo proporzionale</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Costo proporzionale da modificare non trovato</div>
      <FormCostoPerRicavo v-else-if="company && userCanEdit" :costo.sync="cost" :ricavi="ricavi" edit @saved="saveCost" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-cogs-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormCostoPerRicavo: () => import('@/views/components/Operative/Form/FormCostoPerRicavo'),
  },
  data () {
    return {
      cost: null,
      loading: true,
      errorLoadingData: false,
      ricavi: [],
    };
  },
  methods: {
    saveCost (costo) {
      this.$api.updateCostoCogs(this.company.id, costo.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.cogs',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getCostoCogs(this.company.id, this.$route.params.costId)
          .then(res => {
            this.cost = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;

        this.$api.listRicavi(this.company.id)
          .then(res => {
            this.ricavi = res.data.ricavi || [];
          })
          .catch(this.$log.error)
        ;
      },
    },
  },
};

</script>
